<template>
  <div class="Nav">
    <nav class="nav_div">
      <div class="word flex_between">
        <div
          class="nav_ul flex_start"
          :style="{ 'max-width': $type === 1 ? '800px' : '' }"
          @click.stop
        >
          <div class="nav_li nav_img flex_center">
            <img src="@/assets/images/nav_home.png" alt />
          </div>
          <div
            class="nav_li_text flex_center selection"
            @click="homePage"
            :class="index == 0 ? 'this' : ''"
          >
            {{ $t("nav.home") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="memberCenter"
            :class="index == 1 ? 'this' : ''"
          >
            {{ $t("nav.menberCenter") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="product"
            :class="index == 2 ? 'this' : ''"
          >
            {{ $t("nav.proCenter") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="customizedService"
            :class="index == 3 ? 'this' : ''"
          >
            {{ $t("nav.service") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="share"
            :class="index == 4 ? 'this' : ''"
          >
            {{ $t("nav.share") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="services"
            :class="index == 5 ? 'this' : ''"
          >
            {{ $t("nav.afterSale") }}
          </div>
          <div
            class="nav_li_text flex_center"
            @click="abtUs"
            :class="index == 6 ? 'this' : ''"
          >
            {{ $t("nav.aboutUS") }}
          </div>
        </div>

        <div class="nav_phone flex_end">
          <div class="nav_phone_li flex_center">
            <img src="@/assets/images/nav_phone.png" alt />
            028-83352679
          </div>
          <span>/</span>
          <div class="nav_phone_li flex_center">
            <img src="@/assets/images/nav_letter.png" alt />
            hxsq@hanxinchip.cn
          </div>
        </div>
      </div>
    </nav>

    <!-- 产品中心下拉 -->
    <div class="box" @click.stop>
      <div
        :class="goodsList == true ? 'show' : ''"
        class="goods_nav"
        v-if="goodsList && routerOne.length > 0"
      >
        <!-- <Menu :router="router" :num="1" @click="handle($event)"></Menu> -->
        <!-- <el-cascader-panel :options="router" v-model="value" :props="{ expandTrigger: 'hover' }"></el-cascader-panel> -->
        <div class="oneBox">
          <div v-for="(item, index) in routerOne" @mouseenter="tab(index)">
            <div class="flex_between txt" :class="index == idx ? 'bg' : ''">
              <div class="oneName">{{ item.catalogName }}</div>
              <img src="@/assets/images/right.png" alt="" class="right" />
            </div>
          </div>
        </div>
        <div class="twoBox">
          <div class="one_title">{{ routerOne[idx].catalogName }}</div>
          <div class="flex_warp">
            <div
              v-for="(items, indexs) in routerTwo"
              class="twoName"
              @click="towGoods(items.catalogId)"
            >
              <div>{{ items.catalogName }}</div>
              <div
                v-for="(itemx, indexx) in items.children"
                class="threeName"
                @click="towGoods(itemx.catalogId)"
              >
                {{ itemx.catalogName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/header.css";
import Menu from "./menu/Menu";
import bus from "../../assets/js/bus";
export default {
  name: "Nav",
  data() {
    return {
      value: [],
      goodsList: true,
      routerOne: [],
      routerTwo: [],
      arr: [],
      index: 0,
      num: 0,
      name: "",
      is_open: false,
      idx: 0,
      hotArr: [],
      catalogId: "",
    };
  },
  props: {},
  components: {
    Menu,
  },
  methods: {
    tab(index) {
      this.idx = index;
      this.routerTwo = this.routerOne[index].children;
    },
    towGoods(id) {
      this.$emit("selectId", id);
    },
    homePage() {
      this.$router.push("/");
      this.index = 0;
    },
    handle(e) {
      this.name = e.srcElement.innerHTML;
      this.getName(this.arr);
    },
    getName(datas) {
      //遍历树  获取id数组
      for (var i in datas) {
        this.getName(datas[i].children);
        if (datas[i].catalogName == this.name) {
          this.$emit("selectId", datas[i].catalogId);
          this.value = [];
        }
      }
    },
    memberCenter() {
      this.$router.push("/membercenter");
      this.index = 1;
    },
    hotProduct() {
      let url = "/open/product/homeList";
      let data = {
        product: 1,
      };
      this.$post(url, data).then((res) => {
        console.log(res);
        this.hotArr = res.data;
        this.getMenu();
        this.$emit("oneClick", res.data[0].catalogId);
      });
    },
    product() {
      this.index = 2;
      let str = this.$route.path.substring(1).toUpperCase();
      if (str == "GOODSCENTER") {
        //在产品中心页
        this.goodsList = !this.goodsList;
      } else {
        this.$router.push("/goodsCenter");
      }
      if (this.goodsList) {
        //获取目录
        // this.getMenu();
      }
    },
    customizedService() {
      this.$router.push("/customized/apply");
      this.index = 3;
    },
    share() {
      this.$router.push("/tgshare");
      this.index = 4;
    },
    services() {
      this.$router.push("/service");
      this.index = 5;
    },
    abtUs() {
      this.$router.push("/aboutUs");
      this.index = 6;
    },
    //获取产品目录
    getMenu() {
      this.$get("/open/product/allCatalog", {}).then((res) => {
        res.data.unshift({
          catalogName: this.$t("homePage.hot"),
          children: this.hotArr,
        });
        this.arr = res.data;
        this.routerOne = res.data;
        this.routerTwo = this.routerOne[0].children;
      });
    },
    setName(datas) {
      //遍历树  获取id数组
      for (var i in datas) {
        if (datas[i].children) {
          if (datas[i].children.length > 0) {
            this.setName(datas[i].children);
          } else {
            delete datas[i].children;
          }
          datas[i].label = datas[i].catalogName;
          datas[i].value = datas[i].catalogId;
        }
      }
      return datas;
    },
  },
  mounted() {
    this.hotProduct();
    this.$route.path.substring(1).toUpperCase() == "MEMBERCENTER"
      ? (this.index = 1)
      : this.$route.path.substring(1).toUpperCase() == "CUSTOMIZED/APPLY"
      ? (this.index = 3)
      : this.$route.path.substring(1).toUpperCase() == "TGSHARE"
      ? (this.index = 4)
      : this.$route.path.substring(1).toUpperCase() == "ABOUTUS"
      ? (this.index = 6)
      : this.$route.path.substring(1).toUpperCase() == "SERVICE"
      ? (this.index = 5)
      : (this.index = 0);
    if (this.$route.path.substring(1).toUpperCase() != "GOODSCENTER") {
      this.goodsList = false;
    } else {
      this.getMenu();
      bus.$on("datas", (msg) => {
        this.$emit("selectId", msg);
      });
      this.index = 2;
    }
  },
};
</script>

<style scoped>
.nav_ul {
  display: flex;
  min-width: 800px;
  flex: 1;
  justify-content: space-between;
}
.one_title {
  font-size: 14px;
  font-weight: bold;
  color: #0090ff;
  margin-bottom: 20px;
  margin-left: 10px;
  position: relative;
}
.one_title::after {
  content: "";
  position: absolute;
  width: 3px;
  height: 15px;
  background: #0090ff;
  border-radius: 5rpx;
  left: -10px;
  top: 50%;
  transform: translateY(-50%);
}
.txt {
  padding: 10px 20px;
}
.bg {
  background: #0090ff;
}
.box {
  /* width: 100%; */
  background: #fff;
  box-shadow: 0 7px 10px rgb(0, 0, 0, 0.1);
  position: absolute;
  z-index: 999;
  background: white;
  /* left: 30%; */
  /* display: none; */
  left: 50%;
  transform: translateX(-50%);
}
.threeName {
  font-size: 12px;
  margin-left: 5px;
  margin-top: 5px;
}

.threeName:hover {
  color: #0090ff;
}

.twoBox {
  margin-left: 20px;
  margin-top: 20px;
  width: 80%;
}

.oneBox {
  color: #fff !important;
  background: #1c1d33;
  width: calc(20% - 40px);
  /* padding: 20px; */
}

.right {
  width: 8px;
  height: 8px;
}

.twoName {
  margin-right: 20px;
  font-size: 12px;
  margin-bottom: 20px;
  width: 20%;
  cursor: pointer;
}

.twoName:hover {
  color: #0090ff;
}

.oneName {
  font-size: 12px;
  /* font-weight: bold; */
  cursor: pointer;
}

.Nav {
  position: relative;
}

.goods_nav {
  width: 1200px;
  background: #0090ff;
  margin: 0 auto;
  text-align: left;
  display: flex !important;
}

.el-cascader-panel {
  font-size: 16px !important;
  width: 1200px;
  margin: 0 auto;
}

.goods_nav >>> .el-cascader-menu__wrap {
  height: auto !important;
}

.goods_nav >>> .el-scrollbar__wrap {
  overflow: auto;
  margin: 0 !important;
}

.goods_nav >>> .el-cascader-menu__list {
  padding: 20px 0 !important;
  text-align: left;
}

.goods_nav >>> .el-cascader-node {
  font-size: 14px;
  font-weight: bold;
}

.goods_nav >>> .el-cascader-menu:last-child .el-cascader-node {
  display: inline-block;
  font-weight: normal !important;
}

.show {
  display: block;
}

.goods_nav.show {
  /* height: 372px; */
  background: #fff;
}

.goods_nav_item {
  max-height: 100%;
  overflow-y: auto;
  overflow-x: auto;
  max-width: 1280px;
  margin: 0 auto;
}

.nav_li_text.this {
  color: #0090ff;
}
</style>



// WEBPACK FOOTER //
// src/components/assembly/Nav.vue